import { render, staticRenderFns } from "./GravarItemReciboDialog.vue?vue&type=template&id=26c69999&"
import script from "./GravarItemReciboDialog.vue?vue&type=script&lang=js&"
export * from "./GravarItemReciboDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports